import { api } from "../../api"

export async function loadNavigation(): Promise<Navigation[]> {
    let nav = await api<Navigation[]>("navigation", {})
    console.log("NAV:", nav)
    return nav.data
}
